import { Box, Text, Flex, Button, Tooltip, Icon } from '@chakra-ui/react';
import { useMemo, useCallback } from 'react';
import { usePengetahuanDetailContext } from '../../controller/pengetahuan/detail';
import { usePengetahuanQuizContext } from '../../controller/pengetahuan/quiz';
import { MdOutlinePlayArrow } from 'react-icons/md';

/**
 * Quiz component for displaying quiz information and actions.
 *
 * @component
 * @example
 * @author Bagas Prasetyadi
 * return (
 *   <Quiz />
 * )
 */

const Quiz = () => {
  const { pengetahuanItem } = usePengetahuanDetailContext().state;
  const { startQuiz } = usePengetahuanQuizContext().dispatch;

  const pengetahuanId = useMemo(
    () => window.location.pathname.split('/', 4)[3],
    []
  );

  const handleStartQuiz = useCallback(() => {
    startQuiz(pengetahuanId, pengetahuanItem?.status_pengerjaan);
  }, [startQuiz, pengetahuanId, pengetahuanItem?.status_pengerjaan]);

  if (!pengetahuanItem?.pengetahuan_materi_saya?.has_quiz) {
    return (
      <Box
        w="full"
        bg="gray.50"
        rounded="lg"
        p={4}
        border="1px"
        borderColor="gray.400"
      >
        <Text fontSize="md" fontWeight="semibold" textAlign="center">
          Tidak ada quiz pada pengetahuan ini
        </Text>
      </Box>
    );
  }

  const {
    status_pengerjaan,
    jenis_pengetahuan,
    nilai_quiz,
    has_completed_video,
    pengetahuan_materi_saya,
  } = pengetahuanItem;

  const totalSoal =
    pengetahuan_materi_saya?.t_pengetahuan_paket_soal?.total_soal ?? 0;

  const isBelumSelesai = ['belum dikerjakan', 'sedang dikerjakan'].includes(
    status_pengerjaan as string
  );

  const isAsyncLocked =
    !has_completed_video && pengetahuan_materi_saya?.category === 'video';

      const isTooltipDisabled =
    pengetahuan_materi_saya?.category === 'pdf';

  const showButton = isBelumSelesai;

  return (
    <Box
      w="full"
      bg="gray.50"
      rounded="lg"
      p={4}
      border="1px"
      borderColor="gray.400"
    >
      <Flex justifyContent="space-between" alignItems="center">
        <Box>
          <Text fontSize="md" fontWeight="semibold" color="gray.800">
            QUIZ
          </Text>

          {isBelumSelesai ? (
            <Text fontSize="sm" color="gray.600">
              {totalSoal} Soal -{' '}
              <Text
                as="span"
                color="blue.500"
                fontSize="inherit"
                fontWeight="medium"
              >
                Belum Dikerjakan
              </Text>
            </Text>
          ) : (
            <Flex alignItems="center" gap={2}>
              <Text fontSize="sm" color="gray.800">
                {totalSoal} Soal -{' '}
                <Text
                  as="span"
                  color="green.500"
                  fontSize="inherit"
                  fontWeight="medium"
                >
                  Sudah Dikerjakan -
                </Text>{' '}
                <Text
                  as="span"
                  color="gray.800"
                  fontSize="inherit"
                  fontWeight="medium"
                >
                  Nilai: {nilai_quiz ?? 0}
                </Text>
              </Text>
            </Flex>
          )}
        </Box>

        {showButton && (
          <>
            {jenis_pengetahuan === 'synchronized' && (
              <Button
                colorScheme="blue"
                size="md"
                rightIcon={<Icon as={MdOutlinePlayArrow} fontSize="18" />}
                onClick={handleStartQuiz}
              >
                Kerjakan
              </Button>
            )}

            {jenis_pengetahuan === 'asynchronized' && (
              <Tooltip
                label="Tombol akan terbuka ketika sudah menyelesaikan video"
                placement="top"
                gutter={2}
                maxW="none"
                whiteSpace="nowrap"
                hasArrow
                isDisabled={isTooltipDisabled}
              >
                <Button
                  colorScheme="blue"
                  size="md"
                  rightIcon={<Icon as={MdOutlinePlayArrow} fontSize="18" />}
                  disabled={isAsyncLocked}
                  onClick={handleStartQuiz}
                >
                  Kerjakan
                </Button>
              </Tooltip>
            )}
          </>
        )}
      </Flex>
    </Box>
  );
};

export default Quiz;
